document.addEventListener("DOMContentLoaded", function () {
  var a,
    t = {};
  (t = {
    sPrevious: window.scrollY,
    sDirection: "down",
    init: function (e) {
      (a = t).popupInit(e), a.events(e);
    },
    events: function (e) {
      document.addEventListener("click", function (e) {
        (e.target.matches(".popup-close") ||
          e.target.closest(".popup-close")) &&
          a.closePopup(e),
          e.target.matches(".popup-accept") &&
            (a.acceptPopup(e), a.closePopup(e)),
          e.target.matches(".age-verification__popup-close") &&
            (a.agePopup(e), a.closePopup(e)),
          e.target.matches(".age-verification__button-no") && a.ageDeclined(e);
      }),
        document.addEventListener("keyup", function (e) {
          "Escape" === e.key &&
            document
              .querySelectorAll('.popup-open[data-esc-close="true"]')
              .forEach(function (e) {
                a.closePopup(e);
              }),
            "F4" === e.key &&
              document
                .querySelectorAll('.popup-open[data-f4-close="true"]')
                .forEach(function (e) {
                  a.closePopup(e);
                });
        }),
        document.querySelectorAll(".popup-overlay").forEach((t) => {
          t.addEventListener("click", (e) => {
            t.previousElementSibling.matches(
              '.popup-open[data-overlay-close="true"]',
            ) && a.closePopup(t.previousElementSibling);
          });
        });
    },
    popupInit: function (e) {
      document.addEventListener("scroll", function () {
        var e = window.scrollY;
        e > a.sPrevious ? (a.sDirection = "down") : (a.sDirection = "up"),
          (a.sPrevious = e);
      }),
        document.querySelectorAll(".popup").forEach(function (o) {
          if ("manual" === o.getAttribute("data-open-trigger")) {
            let t = o.getAttribute("data-open-manual-selector");
            t &&
              ("#" == t.charAt(0)
                ? document.getElementById(t.slice(1)) &&
                  (document
                    .getElementById(t.slice(1))
                    .classList.add("popup-trigger"),
                  document
                    .getElementById(t.slice(1))
                    .addEventListener("click", (e) => {
                      e.preventDefault(),
                        o.classList.remove("popup-already-opened"),
                        a.openPopup(o),
                        e.target.classList.contains("popup") && a.closePopup(t);
                    }))
                : document.querySelector(t) &&
                  (document.querySelector(t).classList.add("popup-trigger"),
                  document.querySelector(t).addEventListener("click", (e) => {
                    e.preventDefault(),
                      o.classList.remove("popup-already-opened"),
                      a.openPopup(o),
                      e.target.classList.contains("popup") && a.closePopup(t);
                  })));
          }
          (a.isAllowPopup(o) || o.classList.contains("age-verification")) &&
            a.openTriggerPopup(o);
        });
    },
    openTriggerPopup: function (o) {
      var p,
        e,
        t,
        n = o.getAttribute("data-open-trigger");
      "none" !== n ||
        a.getStorage("popup-age-" + o.getAttribute("data-id") || 0) ||
        a.openPopup(o),
        "delay" === n &&
          setTimeout(
            function () {
              a.openPopup(o);
            },
            1e3 * parseInt(o.getAttribute("data-open-delay-number")),
          ),
        "exit" === n &&
          ((p = !0),
          document.addEventListener("mousemove", function (e) {
            var t = window.pageYOffset || document.documentElement.scrollTop;
            e.pageY - t < 7 && p && (a.openPopup(o), (p = !1));
          })),
        "scroll" === n &&
          ((e = o.getAttribute("data-open-scroll-type")),
          (t = o.getAttribute("data-open-scroll-position")),
          document.addEventListener("scroll", function () {
            "px" === e && window.scrollY >= t && a.openPopup(o),
              "%" === e && a.getScrollPercent() >= t && a.openPopup(o);
          })),
        "accept" !== n ||
          a.getStorage("popup-accept-" + o.getAttribute("data-id") || 0) ||
          a.openPopup(o);
    },
    closeTriggerPopup: function (e) {
      var t,
        o,
        p,
        n,
        i = e.getAttribute("data-close-trigger");
      "delay" === i &&
        setTimeout(
          function () {
            a.closePopup(e);
          },
          1e3 * parseInt(e.getAttribute("data-close-delay-number")),
        ),
        "scroll" === i &&
          ((t = e.getAttribute("data-close-scroll-type")),
          (o = e.getAttribute("data-close-scroll-position")),
          (p = e.getAttribute("data-init-scroll-px")),
          (n = e.getAttribute("data-init-scroll-percent")),
          document.addEventListener("scroll", function () {
            "px" === t &&
              ("up" === a.sDirection &&
                window.scrollY < p - o &&
                a.closePopup(e),
              "down" === a.sDirection) &&
              window.scrollY >= p + o &&
              a.closePopup(e),
              "%" === t &&
                ("up" === a.sDirection &&
                  a.getScrollPercent() < n - o &&
                  a.closePopup(e),
                "down" === a.sDirection) &&
                a.getScrollPercent() >= n + o &&
                a.closePopup(e);
          }));
    },
    openPopup: function (e) {
      var t;
      e.classList.contains("popup-already-opened") ||
        e.classList.contains("popup-open") ||
        ("true" === e.getAttribute("data-body-scroll-disable") &&
          (document.body.classList.add("popup-scroll-hidden"),
          "false" === e.getAttribute("data-mobile-disable")) &&
          document.body.classList.add("popup-scroll-hidden-mobile"),
        (t =
          parseInt(a.getStorage("popup-" + e.getAttribute("data-id")) || 0) +
          1),
        a.setStorage("popup-" + e.getAttribute("data-id"), t, {
          expires: e.getAttribute("data-limit-lifetime"),
        }),
        e.classList.add("popup-open"),
        e.setAttribute("data-init-scroll-px", window.scrollY),
        e.setAttribute("data-init-scroll-percent", a.getScrollPercent()),
        (t = e.getAttribute("data-open-animation")),
        a.applyAnimation(e, t),
        a.closeTriggerPopup(e));
    },
    agePopup: function (e) {
      e = (e.target || e).closest(".popup");
      a.setStorage("popup-age-" + e.getAttribute("data-id"), 1, {
        expires: 360,
      });
    },
    ageDeclined: function () {
      document
        .querySelectorAll(".age-verification__question")
        .forEach(function (e) {
          e.classList.remove("show");
        }),
        document
          .querySelector(".age-verification__declined")
          .classList.add("show");
    },
    acceptPopup: function (e) {
      e = (e.target || e).closest(".popup");
      a.setStorage("popup-accept-" + e.getAttribute("data-id"), 1, {
        expires: 360,
      });
    },
    closePopup: function (e) {
      let t = (e.target || e).closest(".popup");
      e = t.getAttribute("data-exit-animation");
      a.applyAnimation(t, e, function () {
        t.classList.add("popup-already-opened"),
          t.classList.remove("popup-open");
      }),
        document.body.classList.remove("popup-scroll-hidden"),
        document.body.classList.remove("popup-scroll-hidden-mobile");
    },
    isAllowPopup: function (e) {
      var t = parseInt(e.getAttribute("data-limit-display") || 0),
        e = parseInt(a.getStorage("popup-" + e.getAttribute("data-id")));
      return !(t && e && t <= e);
    },
    applyAnimation: function (e, t, o) {
      var p,
        e = e.closest(".popup");
      (p = "function" == typeof o ? "popupExitFade" : "popupOpenFade"),
        e.nextElementSibling &&
          (e.nextElementSibling.classList.add("popup-animated", p),
          e.nextElementSibling.addEventListener("animationend", function () {
            this.classList.remove("popup-animated", p);
          })),
        e.querySelector(".popup-wrap").classList.add("popup-animated", t),
        e
          .querySelector(".popup-wrap")
          .addEventListener("animationend", function () {
            this.classList.remove("popup-animated", t),
              "function" == typeof o && o();
          });
    },
    getCookie: function (e) {
      e = document.cookie.match(
        new RegExp(
          "(?:^|; )" +
            e.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
            "=([^;]*)",
        ),
      );
      return e ? decodeURIComponent(e[1]) : void 0;
    },
    setCookie: function (e, t, o) {
      ((o = o || {}).path = o.hasOwnProperty("path") ? o.path : "/"),
        (o.expires = parseInt(o.expires)),
        "number" == typeof o.expires &&
          o.expires &&
          ((o.expires = new Date().setDate(new Date().getDate() + o.expires)),
          (o.expires = new Date(o.expires).toUTCString()));
      var p,
        n = e + "=" + (t = encodeURIComponent(t));
      for (p in o) {
        n += "; " + p;
        var i = o[p];
        !0 !== i && (n += "=" + i);
      }
      document.cookie = n;
    },
    getStorage: function (e) {
      var t = localStorage.getItem(e);
      if (t)
        try {
          var o = JSON.parse(t);
          if (!(o.expires && Date.now() > o.expires)) return o.value;
          localStorage.removeItem(e);
        } catch {}
    },
    setStorage: function (e, t, o = {}) {
      var p,
        t = { value: t, expires: null };
      o.expires &&
        ((p = new Date()).setDate(p.getDate() + parseInt(o.expires, 10)),
        (t.expires = p.getTime())),
        localStorage.setItem(e, JSON.stringify(t));
    },
    getScrollPercent: function () {
      var e = document.documentElement,
        t = document.body,
        o = "scrollTop",
        p = "scrollHeight";
      return ((e[o] || t[o]) / ((e[p] || t[p]) - e.clientHeight)) * 100;
    },
  }).init(),
    document.addEventListener("shopify:section:load", function () {
      t.init();
    }),
    document.addEventListener("shopify:section:unload", function () {
      document.body.classList.remove("popup-scroll-hidden");
    });
});
